import React from 'react';
import { ArrowUpRightIcon, StarIcon } from 'lucide-react';
import { GOOGLE_REVIEWS, GOOGLE_REVIEWS_URL } from '../data/content';
import { Overline } from './Overline';
function Stars({
  rating
}: {
  rating: number;
}) {
  return <span className="flex items-center gap-0.5" aria-label={`${rating} de 5 estrellas`} data-id="element-329" data-mp="1kgife591hxrk">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className={`h-3.5 w-3.5 ${i < rating ? 'fill-champagne text-champagne' : 'text-stone-200'}`} aria-hidden="true" data-id="element-330" data-mp="1gikv9gu4m1v1" data-mpi={i} />)}
    </span>;
}
export function ReviewsSection() {
  return <section id="resenas" className="bg-sand py-24 lg:py-32" data-id="element-331" data-mp="11rlng8147hci">
      <div className="mx-auto max-w-content px-6 lg:px-10" data-id="element-332" data-mp="wt0nm9pryzol">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between" data-id="element-333" data-mp="wqehmeij8s8h">
          <div className="max-w-2xl" data-id="element-334" data-mp="ssgox1pjzo0c">
            <Overline data-id="element-335" data-mp="nraumzg8vsop">Reseñas de Google</Overline>
            <h2 className="mt-6 font-serif text-[2rem] font-light leading-[1.12] text-ink sm:text-[2.5rem]" data-id="element-336" data-mp="ntnmq5fpvjfh">
              Lo que dicen los clientes que ya han renovado su suelo
            </h2>
            <div className="mt-6 flex items-center gap-3" data-id="element-337" data-mp="3qqo4i6japa9b">
              <span className="font-serif text-2xl text-ink" data-id="element-338" data-mp="3cyrhui0ebskb">5,0</span>
              <Stars rating={5} data-id="element-339" data-mp="3gza9oc2agymi" />
              <span className="text-[12.5px] text-stone-600" data-id="element-340" data-mp="3h0lb4589huag">
                Valoración media en Google
              </span>
            </div>
          </div>
          <a href={GOOGLE_REVIEWS_URL} target="_blank" rel="noopener noreferrer" className="group inline-flex w-fit items-center gap-2 rounded-full border border-ink/20 px-6 py-3.5 text-[12.5px] font-medium tracking-wide text-ink transition-[border-color,background-color] duration-200 ease-premium hover:border-ink hover:bg-cream" data-id="element-341" data-mp="diuqs70a3jzd">
            Ver todas en Google
            <ArrowUpRightIcon className="h-4 w-4 transition-transform duration-200 ease-premium group-hover:translate-x-0.5 group-hover:-translate-y-0.5" aria-hidden="true" data-id="element-342" data-mp="2p8nnz2d0f76i" />
          </a>
        </div>

        <ul className="mt-14 grid gap-6 sm:grid-cols-2 lg:gap-8" data-id="element-343" data-mp="ptufylqhqyn8">
          {GOOGLE_REVIEWS.map(review => <li key={review.name} className="flex h-full flex-col rounded-3xl border border-ink/10 bg-white p-8 shadow-card" data-id="element-344" data-mp="l09egjpovmja">
              <div className="flex items-center gap-4" data-id="element-345" data-mp="c2gyddc58auu">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-ink font-serif text-[15px] text-cream" data-id="element-346" data-mp="72ukd1ohqqkz">
                  {review.initials}
                </span>
                <div data-id="element-347" data-mp="3u7aixpzu37wy">
                  <p className="text-[13.5px] font-medium text-ink" data-id="element-348" data-mp="3u82dcxhp2zln">{review.name}</p>
                  <p className="text-[11.5px] text-stone-600" data-id="element-349" data-mp="1wh95lc0avvbq">
                    {review.date}
                    {review.badge ? ` · ${review.badge}` : ''}
                  </p>
                </div>
              </div>
              <div className="mt-6" data-id="element-350" data-mp="3aec32hlwfnqk">
                <Stars rating={review.rating} data-id="element-351" data-mp="3adalduado2zv" />
              </div>
              <p className="mt-5 text-[13.5px] leading-relaxed text-stone-600" data-id="element-352" data-mp="3fblug2sum9h1">“{review.text}”</p>
              <div className="mt-auto flex items-center gap-2 pt-7" data-id="element-353" data-mp="3k4eyspkenfsl">
                <span className="text-[11px] uppercase tracking-overline text-walnut" data-id="element-354" data-mp="3o4pdcqm9jej2">
                  Publicada en Google
                </span>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}